import { QueryClient } from "react-query";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: 1,
            staleTime: 20 * 60 * 1000, // 20 min.
            cacheTime: 30 * 60 * 1000, // 30 min.
        }
    },
});

export default queryClient;


// WEBPACK FOOTER //
// ./src/queries/queryClient.js